<template>
  <div class="car-segment has-text-grey-light">
    <div class="columns">
      <div class="column">
        <h5 class="is-size-5">{{ segment.carProvider.name }}</h5>

        <div class="is-size-7">
            Confirmation number:
          
          <span class="">
            {{ segment.confirmationNumber }}</span>
          </div>

        <div class="columns mt-2 mb-0">
          <div class="column">
            <h5 class="is-size-6 mb-1">
              <div class="is-size-7">Pick-Up:</div>
              <div class="is-size-7 ">{{ segment.startDate.date | formatDate }} @
              {{ segment.startDate.time | formatTime }}</div>
              <div class=" is-size-7">{{
                segment.pickupLocation
              }}</div>
            </h5>
          </div>
          <div class="column">
            <h5 class="is-size-6 mb-2">
              <div class="is-size-7">Drop-Off:</div>
              <div class="is-size-7">{{ segment.endDate.date | formatDate }} @
              {{ segment.endDate.time | formatTime }}</div>
              <div class="is-size-7">{{
                segment.dropoffLocation
              }}</div>
            </h5>
          </div>
        </div>

        <div class="mb-4" v-if="segment.pricingInfo">
          Estimated Total:
          {{ segment.pricingInfo.total | formatPriceFromAmount(2) }}
          <span class=""
            >({{
              segment.pricingInfo.averagePricePerDay
                | formatPriceFromAmount(2)
            }}/day)</span
          >
        </div>

        <b-taglist>
          <b-tag v-for="(type, index) in segment.vehicleType" :key="index" class="has-text-grey-light">
            {{ type }}
          </b-tag>
        </b-taglist>

        <div class="is-size-7">Cancelled by {{ segment.meta.cancelRequester.toLowerCase() }} on {{ segment.meta.cancelDate.date | formatDate }} @ {{ segment.meta.cancelDate.time | formatTime }} </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarSegment",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
